document.addEventListener("DOMContentLoaded", () => {
  $(document).on('submit', '.ajax-form', function (e) {
    const dom = $(this)
    var method = ""
    if ($(this).attr("method") == "GET") {
      method = "GET"
    } else {
      method = ($("input[name='_method']").val() == 'patch' ? "patch" : "post");
    }
    
    dom.find('button[type="submit"]').attr('disabled', 'disabled')
    dom.find("input[type='submit']").attr('disabled', 'disabled')

    e.preventDefault()
    
    $.ajax({
      url: dom.attr('action'),
      method: method,
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      data: dom.serialize(),
      dataType: "json",
      success: function (data) {
        hideModal()
        if (data.href != undefined && data.href != ""){
          loadPage(data.href)
        }
        if (data.message != undefined){
          Notiflix.Notify.success(data.message, {position: 'right-bottom', useIcon: false});
        }
      },
      error: function (jqXHR) {
        console.log("gagal")
        Notiflix.Notify.failure(jqXHR.responseJSON.message, {position: 'right-bottom', useIcon: false});
        dom.find('input[type="submit"]').removeAttr('disabled')
        dom.find('button[type="submit"]').removeAttr('disabled')
      },
      complete: function (res) {
        // console.log(res)
      }
    })
  })
})